import Component from './Billing.container';

export default Component;
